import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {SelectionTagKeyType} from '../models/selection-tag';

@Component({
    selector: 'app-segment-button',
    templateUrl: './segment-button.component.html',
    styleUrls: ['./segment-button.component.scss'],
    standalone: false
})
export class SegmentButtonComponent {
    @Input() isChecked = false;
    @Input() value: SelectionTagKeyType;
    @Input() name: string;
    @Output() buttonClick = new EventEmitter<SelectionTagKeyType>();

    @ViewChild('button') buttonElement: ElementRef;

    check(): void {
        this.buttonClick.emit(this.value);
        this.buttonElement.nativeElement.focus();
    }

}
